import * as React from 'react';
import UnsupportedFilterTypeWarning from 'flow-doctor-lib/components/filters/UnsupportedFilterTypeWarning';
import WalmartDebugEnrollmentFilterRenderer from '../filters/WalmartDebugEnrollmentFilterRenderer';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnsupportedFilterBranchDescription = ({
  filterBranch,
  objectTypeId,
  debugFilterBranch
}) => {
  return /*#__PURE__*/_jsxs(View, {
    marginBlock: "300",
    as: "div",
    children: [/*#__PURE__*/_jsx(UnsupportedFilterTypeWarning, {
      mode: "DIAGNOSIS",
      filterBranch: filterBranch
    }), /*#__PURE__*/_jsx(WalmartDebugEnrollmentFilterRenderer, {
      objectTypeId: objectTypeId,
      filterWidthType: "LIST_FIXED",
      filterBranch: filterBranch,
      debugFilterBranch: debugFilterBranch,
      debugDisplayMode: 'ALL',
      bordered: false
    })]
  });
};
export default UnsupportedFilterBranchDescription;